export const PROFILE_FIELDS = {
  fullCompanyName: 'fullCompanyName',
  inn: 'inn',
  ogrn: 'ogrn',
  kpp: 'kpp',
  website: 'website',
  phone: 'phone',
  email: 'email',
  leaderUid: 'leaderUid',
  fullAddress: 'fullAddress',
  payment: 'payment',
  bankName: 'bankName',
  rs: 'rs',
  bik: 'bik',
  cor: 'cor',
} as const;
